import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';


import { AddTransferChallanOutComponent } from './addTransferChallanOut.component';

import { TransferChallanOutService, SubscribeService } from '../../../services/index';
import * as moment from 'moment';

//import { AddEditSkuComponent } from './addEditSku.component';
//import { NgxPageSize } from '../../shared/index';

//import { SkuService } from '../../services/index';
import { TransferChallanOutModal } from '../../../model/index';

// import * as fromSkuStore from '../../store';
// import * as skuActions from '../../store/actions/sku.actions';
// import * as fromRootStore from '../../reducers';
//import { AppMenu } from '../../../app.component.menu';
//import { AppMenuService } from '../../../app.component.service';
//import { TabsComponent} from '../../../tabs.component';

@Component({
    selector: 'tc-out-list',
    templateUrl: './transferChallanOut.component.html'
})
export class TransferChallanOutComponent implements OnInit {
    @Input('tabTitle') title: string;
    // @Input() active = false;
    // @Input() isCloseable = false;
    // @Input() dataContext;
    //
    isLoadMask: Promise<any>;
    tcOutListData: TransferChallanOutModal[];
    //
    loadingIndicator: boolean = true;
    public mode: string;
    // reorderable: boolean = true;
    //
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        // orderBy: 'company_name',
        // orderDir: 'asc'
    };
    //
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    //
    columns = [];
    toggleCol = [];
    // filterExpand = false;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "search_data": ""
        
    };
    printConfig: any = {
        // title: this.title,
        columns: [],
        rows: []
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private tcOutService: TransferChallanOutService, public subscribeService: SubscribeService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'TC No', prop: 'tc_no', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Tc Out Date', prop: 'tcoutdate', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'To Branch', prop: 'branch_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Team', prop: 'hv_username', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Tot.Items', prop: 'tot_items', sortable: false, width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'Tot. Qty', prop: 'tot_qty', sortable: false, width: 90, minWidth: 90, maxWidth: 90, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 250, minWidth: 250, maxWidth: 250, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        // this.subscribeService.subscribe(($e) => {
        //     this.pageCallback({ offset: 0 });
        // });
        this.subscribeService.publishReloadTcOutGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTcOutDateList();
    }

    onColumnToggle(colToShow) {
        console.log(colToShow);
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getTcOutDateList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "search_data": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getTcOutDateList();
    }
    getTcOutDateList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            // orderColumn: `${this.page.orderBy}`,
            // orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(filterData)
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.tcOutService
            .getTcOutList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.tcOutListData = res.data;
            });
    }
    addEditTcOut(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'tc_out_id': '',
                mode: mode,
                btnTxt: 'Save'
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
            row['btnTxt'] = 'Update';
        } else if (mode == "View") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddTransferChallanOutComponent', Object.assign({}, row), this['params']['tabParams']);

    }

    @ViewChild('printPage') printPage;
    onPrintReport(row: any) {
        let params={
            start: 0,
            limit: 20,
            orderColumn:"tc_out_id",
            orderBy:"tc_out_id",
            orderDir:"asc",
            tc_out_id: row.tc_out_id
        }
        let that = this;
        that.isLoadMask = this.tcOutService
            .getTransferChallanOutModelDetails(params)
            .then(function(res:any){
                row['list']=res.data;
                that.printConfig = {
                    type: that.title,
                    title: 'SOUNDS GOOD HEARING CARE',
                    subTitle: that.title,
                    rows: row,
                    columns: that.columns

                    /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
                     todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
                }

                setTimeout(() => {
                    that.printPage.printPreview();
                }, 100);
            })
      
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }

    deleteTcOut(row: any): void {

        let that = this,
            data = {
                tcoutid: row.tc_out_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Details',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.tcOutService
                .deleteTcOut(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getTcOutDateList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferChallanOut/transferChallanOut.component.ts